import { findMarketByLocale } from "@features/market/config/market-config";

export default function localizePrice(price: number, locale: string) {
  const market = findMarketByLocale(locale);
  const priceHasDecimals = price % 1.0 !== 0;

  return price.toLocaleString(market.locale, {
    style: "currency",
    currency: market.currency,
    currencyDisplay: "narrowSymbol", // Use a narrow format symbol for example $100
    minimumFractionDigits: priceHasDecimals ? 2 : 0, // Show decimals if price has decimals, else hide decimals
    maximumFractionDigits: 2, // Always show max 2 decimals
  });
}
